import React from 'react';
import Feature from '../feature/Feature';
import './whattaasa.css';


const whattaasa = () => {
  return (
    <div className="taasa__whattaasa section__margin" id="fTaasa">
      <div className="taasa__whattaasa-feature">
        <Feature  title="Why Taasa?" text="We have all been affected by the loss of relatives to road traffic incidents. We travel on the roads daily and know what it feels like when you lose loved ones in a road crash, and we believe no one should die as a result of a road crash, therefore we are building solutions to solve the problem."/>
      </div> 
      <div className="taasa__whattaasa-heading"> 
        <h1 className="gradient__text">Our core beliefs.</h1>
        <p>When we started our journey; we needed a compass for direction and to keep us on course. We chose these beliefs to be our true north.</p>
      </div>
      <div className="taasa__whattaasa-container">
        <Feature title="Road Safety" text="Our vision is improving the road safety sector in Africa by championing innovations in emergency response. "/>
        <Feature title="Convenience" text="We make access to emergency response services like ambulances and equipment convenient for you through a mobile app"/>
        <Feature title="Assurance" text="In the event of an accident; families with medical cover are assured of a rapid response under 2 hours from our partners."/>
      </div>    
    </div>
  )
}

export default whattaasa